import { render, staticRenderFns } from "./commoDiscounts.vue?vue&type=template&id=72f23154&scoped=true"
import script from "./commoDiscounts.vue?vue&type=script&lang=js"
export * from "./commoDiscounts.vue?vue&type=script&lang=js"
import style0 from "./commoDiscounts.vue?vue&type=style&index=0&id=72f23154&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f23154",
  null
  
)

export default component.exports